"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useDeepEqualMemo", {
    enumerable: true,
    get: function() {
        return useDeepEqualMemo;
    }
});
const _interop_require_default = require("@swc/helpers/_/_interop_require_default");
const _react = require("react");
const _reactfastcompare = /*#__PURE__*/ _interop_require_default._(require("react-fast-compare"));
function useDeepEqualMemo(value) {
    const memoizedValue = (0, _react.useRef)(value);
    // only update the value if it's not deep equal
    if (!(0, _reactfastcompare.default)(value, memoizedValue.current)) {
        memoizedValue.current = value;
    }
    return memoizedValue.current;
}
